"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
class UError extends Error {
    constructor(message, properties) {
        super(typeof message === 'string' ? message : '');
        if (typeof properties === 'object') {
            for (const key in properties) {
                if (properties[key] === undefined || properties[key] === null)
                    continue;
                this[key] = properties[key];
            }
        }
    }
}
exports.UError = UError;
exports.default = UError;
